import { readStored, writeStored } from '@/lib/storage';

/** Colour theme: follow the OS, or pin light/dark (sets <html data-theme>). */
export type ThemePreference = 'system' | 'light' | 'dark';

const KEY = 'lemon.app.theme';

export const readThemePreference = (): ThemePreference => {
  const stored = readStored(KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'system';
};

export const applyTheme = (preference: ThemePreference): void => {
  const root = document.documentElement;
  if (preference === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', preference);
};

export const setThemePreference = (preference: ThemePreference): void => {
  writeStored(KEY, preference);
  applyTheme(preference);
};
